<p-dialog [(visible)]="isVisible" modal="true" (onHide)="cancel()">
    <p-header>
        Send To Meta API Build
    </p-header>
    <div class="mb-2 mt-2 row align-items-center">
        <div class="col-md-5 font-weight-bold required">
            Ad Account ID
        </div>
        <div class="col-md-7 mb-2">
            <input class="w-100" type="text" [(ngModel)]="adAccountId" pInputText (ngModelChange)="validateAdAccountId()" (blur)="getAudience()"/>
        </div>

        <div class="col-md-5 font-weight-bold required">
            Ad Account Name
        </div>
        <div class="col-md-7 mb-2">
            <input class="w-100" type="text" [(ngModel)]="adAccountName" pInputText />
        </div>

        <div class="col-md-5 font-weight-bold required">
            Facebook Page ID
        </div>
        <div class="col-md-7 mb-2">
            <div class="row mx-0 facebook-page-id">
                <div class="col-6">
                    <div class="small text-muted mb-0">Account</div>
                    <input disabled type="text" [(ngModel)]="metaPageId" pInputText class="w-100" />
                </div>
                <div class="col-6">
                    <div class="mb-0">Override</div>
                    <input pInputText [(ngModel)]="facebookPageId" class="w-100" (keypress)="onlyNumbers($event)"/>
                </div>
            </div>
        </div>

        <div class="col-md-5 font-weight-bold">
            Buying Type
        </div>
        <div class="col-md-7 mb-2">
            <p-dropdown class="mr-0 pr-0" [style]="{width: '100%'}" autoWidth="false" [(ngModel)]="buyingType" [options]="buyingTypeOptions" [disabled]="true"></p-dropdown>
        </div>

        <div class="col-md-5 font-weight-bold">
            Campaign Objective
        </div>
        <div class="col-md-7 mb-2">
            <p-dropdown class="mr-0 pr-0" [disabled]="!!baseCampaign && baseCampaign.campaignType == enumAccountType.FAN365" [style]="{width: '100%'}" autoWidth="false" [(ngModel)]="campaignObjective" [options]="campaignObjectiveOptions" (onChange)="onObjectiveChange()" [autoDisplayFirst]="false" placeholder="Select Campaign Objective"></p-dropdown>
        </div>

        <div class="col-md-5 font-weight-bold">
            Performance Goal
        </div>
        <div class="col-md-7 mb-2">
            <p-dropdown
            [options]="performanceGoalOptions"
            [(ngModel)]="performanceGoal"
            optionLabel="label"
            [autoDisplayFirst]="false"
            [placeholder]="'Select Performance Goal'"
            appendTo="body"
            [disabled]="!campaignObjective"
            [style]="{width:'100%'}"
            optionLabel="label"
            optionValue="value"
            panelStyleClass="performance-goal-panel">

            <!-- Dropdown item -->
            <ng-template let-item pTemplate="item" class="mb-2">
                <div class="goal-item">
                    <div class="goal-title">{{ item.label }}</div>
                    <div class="goal-desc text-muted">{{ item.description }}</div>
                </div>
            </ng-template>

            <!-- Selected item -->
            <ng-template let-item pTemplate="selectedItem" class="mb-2">
                {{ item?.label }}
            </ng-template>
        </p-dropdown>
        </div>
        
        <div class="col-md-5 font-weight-bold">
            Bid Strategy
        </div>
        <div class="col-md-7 mb-2">
            <p-dropdown class="mr-0 pr-0" [disabled]="!!baseCampaign && baseCampaign.campaignType != enumAccountType.FAN365" [style]="{width: '100%'}" autoWidth="false" [(ngModel)]="bidStrategy" [options]="bidStrategyOptions" appendTo="body"></p-dropdown>
        </div>

        <div class="col-md-5 font-weight-bold" [ngClass]="{'required': dataPixelIdcondition()}" *ngIf="!!baseCampaign && baseCampaign.campaignType == enumAccountType.HMP">
            Meta Dataset Pixel ID
        </div>
        <div class="col-md-7 mb-2" *ngIf="!!baseCampaign && baseCampaign.campaignType == enumAccountType.HMP">
            <div class="input-wrapper">
                <input class="w-100 input-with-icon" type="number" [(ngModel)]="metaDataPixelId" pInputText />
                <span tooltipPosition="top" [pTooltip]="'Required for Sales objective with Maximize number of conversions or Maximize value of conversions performance goal.'" tooltipStyleClass="tooltipStyle" class="fal fa-info-circle info info-icon"></span>
            </div>
        </div>

        <div class="col-md-5 font-weight-bold" *ngIf="!!baseCampaign && baseCampaign.campaignType == enumAccountType.HMP">
            RT Custom Audience
        </div>
        <div class="col-md-7 mb-2" *ngIf="!!baseCampaign && baseCampaign.campaignType == enumAccountType.HMP">
            <p-tabView>
                <p-tabPanel header="Include">
                    <p-multiSelect placeholder="Select Audience" appendTo="body" [autoZIndex]="true" [style]="{width: '100%'}" autoWidth="false" [options]="MetaRTAudienceIncludeOptions" [(ngModel)]="SelectedMetaRTAudienceIncludeOptions" optionLabel="label" (onChange)="updateRTAudienceOptions()"></p-multiSelect>
                </p-tabPanel>
                <p-tabPanel header="Exclude">
                    <p-multiSelect placeholder="Select Audience" appendTo="body" [autoZIndex]="true" [style]="{width: '100%'}" autoWidth="false" [options]="MetaRTAudienceExcludeOptions" [(ngModel)]="SelectedMetaRTAudienceExcludeOptions" optionLabel="label" (onChange)="updateRTAudienceOptions()"></p-multiSelect>
                </p-tabPanel>
            </p-tabView>
        </div>

        <div class="col-md-5 font-weight-bold" *ngIf="!!baseCampaign && baseCampaign.campaignType == enumAccountType.HMP">
            LAL Custom Audience
        </div>
        <div class="col-md-7" *ngIf="!!baseCampaign && baseCampaign.campaignType == enumAccountType.HMP">
            <p-tabView>
                <p-tabPanel header="Include">
                    <p-multiSelect placeholder="Select Audience" appendTo="body" [autoZIndex]="true" [style]="{width: '100%'}" autoWidth="false" [options]="MetaLALAudienceIncludeOptions" [(ngModel)]="SelectedMetaLALAudienceIncludeOptions" optionLabel="label" (onChange)="updateLALAudienceOptions()"></p-multiSelect>
                </p-tabPanel>
                <p-tabPanel header="Exclude">
                    <p-multiSelect placeholder="Select Audience" appendTo="body" [autoZIndex]="true" [style]="{width: '100%'}" autoWidth="false" [options]="MetaLALAudienceExcludeOptions" [(ngModel)]="SelectedMetaLALAudienceExcludeOptions" optionLabel="label" (onChange)="updateLALAudienceOptions()"></p-multiSelect>
                </p-tabPanel>
            </p-tabView>
        </div>
    </div>
    <p-footer>
        <div class="mb-3">
            <button (click)="cancel()" pButton class="px-3 flat-btn" label="Cancel"></button>
            <button [disabled]="!adAccountId || !adAccountName || (!facebookPageId && !metaPageId) || (!!baseCampaign && baseCampaign.campaignType == enumAccountType.HMP && (!audienceSelectionCondition() || (dataPixelIdcondition() && !metaDataPixelId))) || !campaignObjective || !performanceGoal || !isAdAccountIdValid" [attr.title]="(!facebookPageId && !metaPageId)? 'Please fill in all required fields.': ((!!baseCampaign && baseCampaign.campaignType == enumAccountType.HMP && !audienceSelectionCondition()) ? 'Please select Include Audience.' : (!campaignObjective ? 'Please select a Campaign Objective.' : (!performanceGoal ? 'Please select a Performance Goal.' : (dataPixelIdcondition() ? 'Please fill in Meta Dataset Pixel ID.' : (!isAdAccountIdValid ? 'Please enter a valid Ad Account ID.' : '')))))" (click)="save()" pButton class="px-3 p-button-primary" label="Save"></button>
        </div>
    </p-footer>

</p-dialog>